module.exports = __webpack_public_path__ + "img/icon-logout.945b4094.svg";